import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";


export default function ParallaxSection({
  children,
  className = "",
  speed = 0.5,
}) {
  const ref = useRef(null);
  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["start end", "end start"],
  // });

  // const y = useTransform(scrollYProgress, [0, 1], [100 * speed, -100 * speed]);

  return (
    <div ref={ref} className={className}>
      <motion.div className="h-full">{children}</motion.div>
    </div>
  );
}
